import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    path: String
  }

  connect() {
  }

  change(event) {
    const value = event.target.value
    fetch(this.pathValue + '?' + new URLSearchParams({ value }), {
      method: 'GET',
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      }
    }).then((response) => response.ok && response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
      });
  }
}